import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5 2.25A2.25 2.25 0 0 1 7.25 0h3.5A2.25 2.25 0 0 1 13 2.25V3h3.999a.75.75 0 0 1 0 1.5H16.5v13.25A2.25 2.25 0 0 1 14.25 20H3.75a2.25 2.25 0 0 1-2.25-2.25V4.5H1A.75.75 0 0 1 1 3h4zm10 11.646V4.5H3v13.25c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75zM6.5 3h5v-.75a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75zM7 7.75a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 7 7.75m4.75.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }